
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/view/terms_conditions",
      function () {
        return require("private-next-pages/view/terms_conditions.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/view/terms_conditions"])
      });
    }
  